// useHighConfidenceBoard — reads get_high_confidence_board(): football match-winner
// picks ranked by STRIKZA CONVICTION (0-100), not raw win probability. The engine
// surfaces its strongest reads — including flagged upsets — on top; obvious book-
// mirror chalk falls to the bottom. Outputs-only (no methodology fields).

import { useEffect, useMemo, useState } from "react";
import { getBrowserClient } from "../../supabase/browser.ts";

export interface HighConfidencePick {
  fixture_id: string;
  home_team: string;
  away_team: string;
  competition: string | null;
  kickoff_at: string;
  market: string;
  selection: string;
  fair_odds: number | null;
  confidence: number;
  band: "HIGH" | "MEDIUM" | "LOW";
  is_upset: boolean;
  note: string;
}

export function useHighConfidenceBoard(): {
  picks: HighConfidencePick[];
  loading: boolean;
  error: string | null;
} {
  const supabase = useMemo(() => getBrowserClient(), []);
  const [picks, setPicks] = useState<HighConfidencePick[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    setError(null);
    (supabase.rpc as unknown as (
      name: string,
      params?: Record<string, unknown>,
    ) => Promise<{ data: unknown; error: { message: string } | null }>)(
      "get_high_confidence_board",
      { p_hours: 120, p_limit: 40 },
    ).then(({ data, error: e }) => {
      if (cancelled) return;
      if (e) {
        setError(e.message);
        setPicks([]);
      } else {
        setPicks((Array.isArray(data) ? data : []) as HighConfidencePick[]);
      }
      setLoading(false);
    });
    return () => {
      cancelled = true;
    };
  }, [supabase]);

  return { picks, loading, error };
}
